export default {
	'failedConversationAuthorization': 'errorConversationUnknown',
	'ConversationAlreadyHasOwner': 'errorConversationAlreadyHasOwner',
	'Failed authorization: ConversationAlreadyHasOwner': 'errorConversationAlreadyHasOwner',
	unknown: 'errorConversationUnknown'
};

